import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { AuthService } from '../route/auth/auth.service';
import { UserInformation } from '@lfw/roesberg.liveforms.core';
import { AppUrls } from '../route/app-urls';
import { SettingsFactory, UserSettingsDto } from '@lfw/roesberg.liveforms.core';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NetworkService } from '../network.service';
import { OfflineSettingsService } from './offline-settings.service';

@Injectable({
  providedIn: 'root'
})
export class UserInformationService {
  public userInformation: UserInformation = new UserInformation('', '', '', '');
  private authService: AuthService = inject(AuthService);
  private http: HttpClient = inject(HttpClient);
  private networkService = inject(NetworkService);
  private offlineSettingsService = inject(OfflineSettingsService);

  constructor() {
    this.authService.isAuthenticated$
      .pipe(
        takeUntilDestroyed(),
        tap((isAuthenticated) => {
          if (isAuthenticated) {
            const userInfos: Record<string, any> = this.authService.identityClaims;
            this.userInformation.userID = userInfos.user_id;
            this.userInformation.department = userInfos.user_department;
          } else {
            console.log(`userinfo not authenticated`);
            this.userInformation = new UserInformation('', '', '', '');
          }
        })
      )
      .subscribe();
  }

  public getUser(): Observable<UserInformation> {
    return this.http.get<UserSettingsDto>(AppUrls.getApiUrl(AppUrls.urlSettings, 'get')).pipe(
      tap((userSetting) => this.offlineSettingsService.saveUserOffline(userSetting)),
      map((dtoRaw) => {
        this.userInformation.loginName = dtoRaw.userName;
        this.userInformation.displayName = dtoRaw.displayName;
        this.userInformation.userGroups = SettingsFactory.UserGroupsFromDTO(dtoRaw.userGroups);
        return this.userInformation;
      }),
      take(1)
    );
  }
}
